export enum CounterIndexAction {
  Index = 'index',
  Zero = 'zero',
}
